// extracted by mini-css-extract-plugin
export default {"mainCard":"Po-z","products":"Qo-z","title":"Ro-z","heading_section":"So-z"};